/**
 * On-demand probe of the user's `prefers-reduced-motion` setting.
 *
 * Returns `true` when the OS-level "reduce motion" preference is active, in
 * which case animation call-sites should skip tween loops and jump to the
 * end state. Call on demand from the animator each tick / each animation
 * start — the matchMedia query itself is cheap, and reading per-frame keeps
 * the helper stateless (no listener registration / cleanup).
 *
 * Safe to call in non-browser contexts (SSR, tests without happy-dom) — when
 * `window` or `matchMedia` are unavailable the helper returns `false` (the
 * "no preference" default), which is also what the CSS spec falls back to.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  const mm = window.matchMedia;
  if (typeof mm !== "function") return false;
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}
